import React, { useState, useEffect } from 'react';
import { Label, Input, FormGroup, Col } from 'reactstrap';
import { HandLoadUnload, Dolly, Hazmat, TWIC, PalletJack, Liftgate, Umbrella, Medical, PPE } from '../../../../assets/svgs/ToolsAndEquipments';
import { supportsLiftgateForVehicleType } from '../vehicleTypeApi';

const Tools = ({
  setIsDolly,
  isDolly,
  setIsHandLoadUnload,
  isHandLoadUnload,
  setIsHazmat,
  isHazmat,
  isTWICCard,
  setIsTWICCard,
  isLiftgate,
  setIsLiftgate,
  isPalletJack,
  setIsPalletJack,
  isWeatherProtection,
  setIsWeatherProtection,
  isMedical,
  setIsMedical,
  isPPE,
  setIsPPE,
  vehicleType
}) => {
  const [isDollyHover, setIsDollyHover] = useState(false);
  const [isHandLoadUnloadHover, setIsHandLoadUnloadHover] = useState(false);
  const [isHazmatHover, setIsHazmatHover] = useState(false);
  const [isTWICCardHover, setIsTWICCardHover] = useState(false);
  const [isLiftgateHover, setIsLiftgateHover] = useState(false);
  const [isPalletJackHover, setIsPalletJackHover] = useState(false);
  const [isUmbrellaHover, setIsUmbrellaHover] = useState(false);
  const [isMedicalHover, setIsMedicalHover] = useState(false);
  const [isPPEHover, setIsPPEHover] = useState(false);
  const [isHandLoadUnloadDisabled, setIsHandLoadUnloadDisabled] = useState(false);
  const [isLiftgateDisabled, setIsLiftgateDisabled] = useState(false);

  useEffect(() => {
    if (isLiftgate) {
      setIsHandLoadUnloadDisabled(true);
    } else {
      setIsHandLoadUnloadDisabled(false);
    }
    setIsHandLoadUnload(false);
  }, [isLiftgate]);

  useEffect(() => {
    if (vehicleType) {
      setIsLiftgateDisabled(!supportsLiftgateForVehicleType(vehicleType));
      setIsLiftgate(false);
    }
  }, [vehicleType]);

  return (
    <>
      <Col md="auto">
        <Label for="equipment_tools" style={{ textAlign: 'left' }}>
          Equipments and Tools Needed
        </Label>
        <div style={{ marginTop: '12px' }}>
          <FormGroup check>
            <Label check>
              <div style={{ marginTop: '-12px' }} onMouseEnter={() => setIsHandLoadUnloadHover(true)} onMouseLeave={() => setIsHandLoadUnloadHover(false)}>
                <HandLoadUnload name="HandLoadUnload" fill={isHandLoadUnloadDisabled ? '#333333' : '#5e72e4'}></HandLoadUnload>
              </div>
              {!isHandLoadUnloadDisabled && (
                <Input
                  type="checkbox"
                  id="tool-check"
                  onClick={() => {
                    setIsHandLoadUnload(!isHandLoadUnload);
                  }}
                  disabled={isHandLoadUnloadDisabled}
                />
              )}
              <span className="form-check-sign" style={{ marginLeft: '12px' }} />
              {isHandLoadUnloadHover && 'Hand load'}
            </Label>
          </FormGroup>
        </div>
        <div style={{ marginTop: '10px' }}>
          <FormGroup check>
            <Label check>
              <div style={{ marginTop: '-15px', marginLeft: '10px' }} onMouseEnter={() => setIsLiftgateHover(true)} onMouseLeave={() => setIsLiftgateHover(false)}>
                <Liftgate name="Liftgate" fill={isLiftgateDisabled ? '#333333' : '#5e72e4'}></Liftgate>
              </div>
              {!isLiftgateDisabled && (
                <Input
                  type="checkbox"
                  id="tool-check"
                  onClick={() => {
                    setIsLiftgate(!isLiftgate);
                  }}
                  disabled={isLiftgateDisabled}
                />
              )}
              <span className="form-check-sign" style={{ marginLeft: '15px', marginBottom: '2px' }} />
              {isLiftgateHover && 'Liftgate'}
            </Label>
          </FormGroup>
        </div>

        <div style={{ marginTop: '10px' }}>
          <FormGroup check>
            <Label check>
              <div style={{ marginTop: '-15px', marginLeft: '10px' }} onMouseEnter={() => setIsPalletJackHover(true)} onMouseLeave={() => setIsPalletJackHover(false)}>
                <PalletJack name="PalletJack"></PalletJack>
              </div>
              <Input
                type="checkbox"
                id="tool-check"
                onClick={() => {
                  setIsPalletJack(!isPalletJack);
                }}
              />
              <span className="form-check-sign" style={{ marginLeft: '12px' }} />
              {isPalletJackHover && 'Pallet Jack'}
            </Label>
          </FormGroup>
        </div>

        <div style={{ marginTop: '10px' }}>
          <FormGroup check>
            <Label check>
              <div style={{ marginTop: '-15px' }} onMouseEnter={() => setIsDollyHover(true)} onMouseLeave={() => setIsDollyHover(false)}>
                <Dolly name="Dolly"></Dolly>
              </div>
              <Input
                type="checkbox"
                id="tool-check"
                onClick={() => {
                  setIsDolly(!isDolly);
                }}
              />
              <span className="form-check-sign" style={{ marginLeft: '20px' }} />
              {isDollyHover && 'Dolly'}
            </Label>
          </FormGroup>
        </div>
      </Col>
      <Col md="auto" style={{ marginLeft: -25, width: '12%' }}>
        <div style={{ marginTop: '20px' }}>
          <FormGroup check>
            <Label check>
              <div style={{ marginTop: '-14px' }} onMouseEnter={() => setIsHazmatHover(true)} onMouseLeave={() => setIsHazmatHover(false)}>
                <Hazmat name="Hazmat"></Hazmat>
              </div>
              <Input
                type="checkbox"
                id="tool-check"
                onClick={() => {
                  setIsHazmat(!isHazmat);
                }}
              />
              <span className="form-check-sign" style={{ marginLeft: '12px' }} />
              {isHazmatHover && 'Hazmat'}
            </Label>
          </FormGroup>
        </div>
        <div style={{ marginTop: '10px' }}>
          <FormGroup check onMouseEnter={() => setIsTWICCardHover(true)} onMouseLeave={() => setIsTWICCardHover(false)}>
            <Label check>
              <div style={{ marginTop: '-12px' }}>
                <TWIC name="TWIC"></TWIC>
              </div>
              <Input
                type="checkbox"
                id="tool-check"
                onClick={() => {
                  setIsTWICCard(!isTWICCard);
                }}
              />
              <span className="form-check-sign" style={{ marginLeft: '5px' }} />
              {isTWICCardHover && 'TWIC Card'}
            </Label>
          </FormGroup>
        </div>
        <div style={{ marginTop: '10px' }}>
          <FormGroup check>
            <Label check>
              <div style={{ marginTop: '-12px' }} onMouseEnter={() => setIsUmbrellaHover(true)} onMouseLeave={() => setIsUmbrellaHover(false)}>
                <Umbrella name="Umbrella"></Umbrella>
              </div>
              <Input
                type="checkbox"
                id="tool-check"
                onClick={() => {
                  setIsWeatherProtection(!isWeatherProtection);
                }}
              />
              <span className="form-check-sign" style={{ marginLeft: '2px' }} />
              {isUmbrellaHover && 'Weather Protection'}
            </Label>
          </FormGroup>
        </div>

        <div style={{ marginTop: '10px' }}>
          <FormGroup check>
            <Label check>
              <div style={{ marginTop: '-12px' }} onMouseEnter={() => setIsPPEHover(true)} onMouseLeave={() => setIsPPEHover(false)}>
                <PPE name="PPE"></PPE>
              </div>
              <Input
                type="checkbox"
                id="tool-check"
                onClick={() => {
                  setIsPPE(!isPPE);
                }}
              />
              <span className="form-check-sign" style={{ marginLeft: '12px' }} />
              {isPPEHover && 'PPE'}
            </Label>
          </FormGroup>
        </div>

        <div style={{ marginTop: '10px' }}>
          <FormGroup check>
            <Label check>
              <div style={{ marginTop: '-12px' }} onMouseEnter={() => setIsMedicalHover(true)} onMouseLeave={() => setIsMedicalHover(false)}>
                <Medical name="TWIC"></Medical>
              </div>
              <Input
                type="checkbox"
                id="tool-check"
                onClick={() => {
                  setIsMedical(!isMedical);
                }}
              />
              <span className="form-check-sign" style={{ marginLeft: '12px' }} />
              {isMedicalHover && 'Medical'}
            </Label>
          </FormGroup>
        </div>
      </Col>
    </>
  );
};

export default Tools;
